import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_CIRCLE_CHEVRON_LEFT: GlameraIconDefinition = {
  name: 'circle-chevron-left',
  viewBox: '0 0 24 24',
  svg: `
    <circle class="glm-circle-chevron-left-circle" cx="12" cy="12" r="10"></circle>
    <path class="glm-circle-chevron-left-arrow" d="m14 16-4-4 4-4"></path>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-circle-chevron-left-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './circle-chevron-left.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class CircleChevronLeftIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_CIRCLE_CHEVRON_LEFT;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
